import React, { useEffect } from 'react';
import {
  Switch,
  Route,
  Redirect,
  useLocation,
  useHistory,
} from 'react-router-dom';

import AdminDashboard from '../pages/Dashboard/adminDashboard';
import MainDashboard from '../pages/MainDashboard';
import SiteConfiguration from '../pages/SiteConfiguration';
import ChangePassword from '../pages/Login/changePassword';
import UserManagement from '../pages/Management/User';
import CustomerManagement from '../pages/Management/Customer';
import ManageCustomer from '../pages/Management/Customer/manageCustomer';
import ManageUser from '../pages/Management/User/manageUser';
import PrivateRoute from './privateRoute';
import ErrorPage from '../pages/error';
import { IModulesPermissions } from '../shared/models/rolesPermissionModel';
import { get } from 'lodash';
import Report from '../pages/Reports';
import ReturnNote from '../pages/ReturnNote';
import UserProfile from '../pages/UserProfile';
import { IUser, UserRole } from '../shared/models/adminModels';
interface IProps {
  loggedInUser: IUser;
}
const MainRoute = (props: IProps) => {
  const { permission } = props.loggedInUser
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.pathname === '/') {
      const { userType } = props.loggedInUser;
      if (userType === Number(UserRole.Admin)) {
        history.push('/admin-dashboard');
      } else {
        history.push('/main-dashboard');
      }
    }
  }, [])
  return (
    <Switch>
      <PrivateRoute exact path='/admin-dashboard' component={AdminDashboard}
        permission={get(permission.adminDashboard, 'view', false)} />
      <PrivateRoute exact path='/main-dashboard' component={MainDashboard}
        permission={get(permission.productReturnDashboard, 'view', false)} />
      <PrivateRoute exact path='/return-note/:id' component={ReturnNote}
        permission={get(permission.productReturnDashboard, 'view', false)} />
      <PrivateRoute exact path='/return-note/' component={ReturnNote}
        permission={get(permission.productReturnDashboard, 'create', false)} />
      <PrivateRoute exact path='/site-configuration' component={SiteConfiguration}
        permission={get(permission.systemConfiguration, 'view', false)} />
      <Route exact path='/forgot-password' component={() => <Redirect to='/admin-dashboard' />} />
      <Route exact path='/reset-password' component={() => <Redirect to='/admin-dashboard' />} />
      <Route exact path='/change-password' component={ChangePassword} />
      {/* User*/}
      <PrivateRoute exact path='/reports' component={Report}
        permission={get(permission.reports, 'view', false)} />
      {/* User*/}
      <PrivateRoute exact path='/manage-users' component={UserManagement}
        permission={get(permission.manageUsers, 'view', false)} />
      <PrivateRoute exact path='/manage-user/:id' component={ManageUser}
        permission={get(permission.manageUsers, 'edit', false)} />
      <PrivateRoute exact path='/manage-user' component={ManageUser}
        permission={get(permission.manageUsers, 'create', false)} />
      {/* Customer */}
      <PrivateRoute exact path='/manage-customers' component={CustomerManagement}
        permission={get(permission.manageCustomer, 'view', false)} />
      <PrivateRoute exact path='/manage-customer/:id' component={ManageCustomer}
        permission={get(permission.manageCustomer, 'edit', false)} />
      <PrivateRoute exact path='/manage-customer' component={ManageCustomer}
        permission={get(permission.manageCustomer, 'create', false)} />
      <PrivateRoute exact path='/profile' component={UserProfile}
        permission={get(permission.manageUserProfile, 'view', false)} />
      <Route component={ErrorPage} />
    </Switch>
  );
}

export default MainRoute;